import React from 'react';

export default function HowItWorks() {
  return (
    <section id='how' className='am-how-it-works am-section'>
      <div className='am-container am-how-inner'>
        <h2 className='am-how-title'>How it works</h2>
        <p className='am-how-lead'>
          Simple, fast, and hassle-free—just a few steps, and your space will be clean and well taken care of. Choose
          your service, schedule, and relax while we do the rest!
        </p>

        <div className='am-how-steps'>
          <article className='am-how-step'>
            <div className='am-how-icon'>
              <img src='/assets/step1.webp' alt='Select your services' />
            </div>
            <h4 className='am-how-step-title'>Select your services</h4>
            <p className='am-how-step-desc'>Choose the cleaning or inspection service that best fits your needs.</p>
          </article>

          <article className='am-how-step'>
            <div className='am-how-icon'>
              <img src='/assets/step2.webp' alt='Schedule with us' />
            </div>
            <h4 className='am-how-step-title'>Schedule with us</h4>
            <p className='am-how-step-desc'>Pick a convenient date and time for our team to visit your location.</p>
          </article>

          <article className='am-how-step'>
            <div className='am-how-icon'>
              <img src='/assets/step3.webp' alt='Cleaning done' />
            </div>
            <h4 className='am-how-step-title'>Cleaning done</h4>
            <p className='am-how-step-desc'>
              Sit back and relax while we handle the rest, leaving your space spotless!
            </p>
          </article>
        </div>

        <div className='am-how-cta-row'>
          <a className='am-cta am-cta-large' href='#quote'>
            REQUEST A FREE QUOTE
          </a>
        </div>
      </div>
    </section>
  );
}
